import { instance as axios } from '@/plugins/axios'

export function useRequest() {
    let result = {}

    const useAxios = (data) => {
        return new Promise((resolve, reject) => {
            axios(data).then((res) => {
                resolve(res)
            }).catch((err) => {
                reject(err)
            })
        })
    }

    const useApi = async({ url = '', method = 'get' }, config = {}) => {
        if (!url) {
            throw new Error('请求的url不能为空')
        }

        const data = {}
        data[method === 'get' ? 'params' : 'data'] = config

        try {
            const res = await useAxios({ url, method, ...data })
            if (res.status === 200) {
                result = res.data ? res.data : res
            }
        } catch (error) {
            console.log('useApi', error)
        }

        return {
            result
        }
    }

    return {
        useApi
    }
}
